import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import MenusPage from "./pages/MenusPage";
import PlansPage from "./pages/PlansPage";
import WhatIsKetoPage from "./pages/WhatIsKetoPage";
import WelcomeModal from "./components/WelcomeModal";
import ChatBubble from "./components/ChatBubble";
import { Toaster } from "./components/ui/toaster";

function App() {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("ka_welcome_seen");
    if (!seen) {
      const t = setTimeout(() => setShowWelcome(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const closeWelcome = () => {
    sessionStorage.setItem("ka_welcome_seen", "1");
    setShowWelcome(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/menus" element={<MenusPage />} />
            <Route path="/plans" element={<PlansPage />} />
            <Route path="/what-is-keto" element={<WhatIsKetoPage />} />
          </Routes>
        </Layout>
        <ChatBubble />
        <WelcomeModal open={showWelcome} onClose={closeWelcome} />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
